import { render } from "./NewUserModal.vue?vue&type=template&id=3846c52a&scoped=true&ts=true"
import script from "./NewUserModal.vue?vue&type=script&lang=ts"
export * from "./NewUserModal.vue?vue&type=script&lang=ts"

import "./NewUserModal.vue?vue&type=style&index=0&id=3846c52a&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3846c52a"]])

export default __exports__